export default "__VITE_ASSET__D3E6ge3g__"